// @core/api/endpoints/task/get_task_custom_fields.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTaskCustomFieldsResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get task custom fields
 * Returns all custom field values set on a task, with field definition metadata for rendering.
 */
export async function GetTaskCustomFields(
  task_id: string,
  options?: RequestOptions
): Promise<GetTaskCustomFieldsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/custom-fields`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.get<GetTaskCustomFieldsResponse>(requestPath, { ...requestOptions });
}
